var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurchased(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 57,
    viewBox: "0 0 54 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 56.1951C16.4634 56.1951 10.8 53.2537 6.55244 47.9195C2.32683 42.6183 0 35.5829 0 28.0976C0 20.6122 2.32683 13.5768 6.55244 8.27561C10.8 2.94146 16.4634 0 22.5 0C28.5366 0 34.2 2.94146 38.4476 8.27561C42.6732 13.5768 45 20.6122 45 28.0976C45 35.5829 42.6732 42.6183 38.4476 47.9195C34.2 53.2537 28.5366 56.1951 22.5 56.1951ZM22.5 1.09756C10.7012 1.09756 1.09756 13.2146 1.09756 28.0976C1.09756 42.9805 10.7012 55.0976 22.5 55.0976C34.2988 55.0976 43.9024 42.9805 43.9024 28.0976C43.9024 13.2146 34.2988 1.09756 22.5 1.09756Z",
    fill: "url(#paint0_linear_1149_26081)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5004 50.5976C17.6382 50.5976 13.0723 48.2378 9.65892 43.9574C6.25648 39.7208 4.39062 34.0903 4.39062 28.0976H5.48819C5.48819 39.8964 13.1162 49.5 22.5004 49.5C31.8845 49.5 39.5126 39.8964 39.5126 28.0976C39.5126 16.2988 31.8845 6.69516 22.5004 6.69516C13.7199 6.69516 6.44306 14.9708 5.57599 25.9464L4.47843 25.8586C4.91745 20.3488 6.96989 15.2561 10.2626 11.5025C13.6101 7.69394 17.9565 5.5976 22.5004 5.5976C27.3626 5.5976 31.9284 7.95735 35.3418 12.2378C38.7333 16.4854 40.6101 22.1159 40.6101 28.0976C40.6101 34.0793 38.7443 39.7208 35.3418 43.9574C31.9284 48.2378 27.3626 50.5976 22.5004 50.5976Z",
    fill: "url(#paint1_linear_1149_26081)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 56.1951H22.5V55.0976H31.5C43.2988 55.0976 52.9024 42.9805 52.9024 28.0976C52.9024 13.2146 43.2988 1.09756 31.5 1.09756H22.5V0H31.5C37.5366 0 43.2 2.94146 47.4476 8.27561C51.6732 13.5768 54 20.6122 54 28.0976C54 35.5829 51.6732 42.6183 47.4476 47.9195C43.2 53.2537 37.5366 56.1951 31.5 56.1951Z",
    fill: "url(#paint2_linear_1149_26081)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4531 27.5488H53.4531V28.6463H44.4531V27.5488Z",
    fill: "url(#paint3_linear_1149_26081)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8047 17.0122H51.6949V18.1098H42.8047V17.0122Z",
    fill: "url(#paint4_linear_1149_26081)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8555 9.21948H47.7457V10.317H38.8555V9.21948Z",
    fill: "url(#paint5_linear_1149_26081)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1445 3.51221H42.1445V4.60977H33.1445V3.51221Z",
    fill: "url(#paint6_linear_1149_26081)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8047 38.0854H51.6949V39.1829H42.8047V38.0854Z",
    fill: "url(#paint7_linear_1149_26081)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8555 45.8781H47.7457V46.9756H38.8555V45.8781Z",
    fill: "url(#paint8_linear_1149_26081)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1445 51.5854H42.1445V52.6829H33.1445V51.5854Z",
    fill: "url(#paint9_linear_1149_26081)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4981 45.1098C22.2895 45.1098 22.103 44.989 22.0042 44.8025L13.7725 28.339C13.6956 28.1854 13.6956 27.9988 13.7725 27.8451L22.0042 11.3817C22.092 11.1951 22.2895 11.0744 22.4981 11.0744C22.7066 11.0744 22.8932 11.1951 22.992 11.3817L31.2237 27.8451C31.3005 27.9988 31.3005 28.1854 31.2237 28.339L22.992 44.8025C22.8932 44.989 22.7066 45.1098 22.4981 45.1098ZM14.881 28.0976L22.4981 43.3317L30.1151 28.0976L22.4981 12.8634L14.881 28.0976Z",
    fill: "url(#paint10_linear_1149_26081)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2073 31.939C19.0975 31.939 18.9987 31.9061 18.9 31.8512L13.9609 28.5586L14.5646 27.6476L19.2951 30.7976L28.3829 28.1964L28.6792 29.25L19.35 31.9171C19.3061 31.9281 19.2622 31.939 19.2073 31.939Z",
    fill: "url(#paint11_linear_1149_26081)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1149_26081",
    x1: 0,
    y1: 28.0976,
    x2: 45,
    y2: 28.0976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C05B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1149_26081",
    x1: 4.39062,
    y1: 28.0976,
    x2: 40.6101,
    y2: 28.0976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C05B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1149_26081",
    x1: 22.5,
    y1: 28.0976,
    x2: 54,
    y2: 28.0976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C05B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1149_26081",
    x1: 44.4531,
    y1: 28.0975,
    x2: 53.4531,
    y2: 28.0975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C05B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1149_26081",
    x1: 42.8047,
    y1: 17.561,
    x2: 51.6949,
    y2: 17.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C05B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1149_26081",
    x1: 38.8555,
    y1: 9.76826,
    x2: 47.7457,
    y2: 9.76826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C05B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1149_26081",
    x1: 33.1445,
    y1: 4.06099,
    x2: 42.1445,
    y2: 4.06099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C05B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1149_26081",
    x1: 42.8047,
    y1: 38.6342,
    x2: 51.6949,
    y2: 38.6342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C05B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1149_26081",
    x1: 38.8555,
    y1: 46.4268,
    x2: 47.7457,
    y2: 46.4268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C05B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1149_26081",
    x1: 33.1445,
    y1: 52.1342,
    x2: 42.1445,
    y2: 52.1342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C05B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1149_26081",
    x1: 13.7148,
    y1: 28.0921,
    x2: 31.2813,
    y2: 28.0921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C05B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1149_26081",
    x1: 13.9609,
    y1: 29.7933,
    x2: 28.6792,
    y2: 29.7933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C05B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchased);
export default __webpack_public_path__ + "static/media/Purchased.887c5eae1b4deec806175d0e85f38d73.svg";
export { ForwardRef as ReactComponent };